// extracted by mini-css-extract-plugin
export var bookingLink = "card--blog-module--booking-link--b81d5";
export var bookingReq = "card--blog-module--booking-req--dd47d";
export var content = "card--blog-module--content--dca9b";
export var costWrapper = "card--blog-module--cost-wrapper--d5551";
export var location = "card--blog-module--location--3755d";
export var timesGrid = "card--blog-module--times-grid--4eec0";